export default "__VITE_ASSET__CCPYDq3r__"